// Typed facade over the ported (untyped) design modules.
//
// ui.tsx / interactions.tsx / i18n.tsx are verbatim ports of the design
// bundle's loose JSX and carry `@ts-nocheck`. Their inferred export signatures
// treat every destructured prop as required, which fights the typed screens.
// Re-exporting each as `any` here lets the screens stay type-checked for their
// own logic while treating the design primitives as loose view components —
// mirroring how the prototype shipped.
import * as ui from './ui'
import * as interactions from './interactions'
import * as i18n from './i18n'
import {
  ScreenSkeleton as _ScreenSkeleton,
  TaskCardSkeleton as _TaskCardSkeleton,
  DealCardSkeleton as _DealCardSkeleton,
  AIBlockSkeleton as _AIBlockSkeleton,
} from './skeleton'
import { STAGES as _STAGES } from './runtime'

// Ordered Bitrix funnel stages (runtime.ts), keyed by raw STAGE_ID. Used by the
// deal StageStepper / StageTransitionSheet.
export interface StageDef { id: string; label: string; descKey: string; star?: boolean }
export const STAGES: Record<string, StageDef> = _STAGES as Record<string, StageDef>

export const Icon: any = ui.Icon
export const Avatar: any = ui.Avatar
export const Button: any = ui.Button
export const IconButton: any = ui.IconButton
export const Badge: any = ui.Badge
export const StatusBadge: any = ui.StatusBadge
export const DeadlineTimer: any = ui.DeadlineTimer
export const AIInline: any = ui.AIInline
export const LogoMark: any = ui.LogoMark
export const MiniHeader: any = ui.MiniHeader
export const SectionHeader: any = ui.SectionHeader
export const SourceIcon: any = ui.SourceIcon
export const Skel: any = ui.Skel
export const EmptyState: any = ui.EmptyState
export const Sparkline: any = ui.Sparkline
export const StageChip: any = ui.StageChip
export const EscBadge: any = ui.EscBadge
export const AgentBadge: any = ui.AgentBadge
export const IntentBadge: any = ui.IntentBadge
export const IntentDot: any = ui.IntentDot
export const Money: any = ui.Money
export const Toggle: any = ui.Toggle
export const CHANNEL_LABEL: Record<string, string> = ui.CHANNEL_LABEL
export const workdayStatus: (
  nowMin: number,
  wh?: { start?: string; end?: string; lunchStart?: string; lunchEnd?: string },
) => { phase: string; text: string } = ui.workdayStatus

export const ToastProvider: any = interactions.ToastProvider
export const useToast: () => (msg: string, opts?: { undo?: () => void; duration?: number }) => string = interactions.useToast as any
export const SwipeableRow: any = interactions.SwipeableRow
export const PullToRefresh: any = interactions.PullToRefresh
export const haptic: any = interactions.haptic

export const t: (key: string, vars?: Record<string, unknown>) => string = i18n.t as any
export const setLang: (lang: string) => void = i18n.setLang

export const ScreenSkeleton: any = _ScreenSkeleton
export const TaskCardSkeleton: any = _TaskCardSkeleton
export const DealCardSkeleton: any = _DealCardSkeleton
export const AIBlockSkeleton: any = _AIBlockSkeleton
